<script setup>
import { onMounted } from 'vue'
import GraphChart from './GraphChart.vue'
import SSTGraph from './SSTGraph.vue'
import { useBreadStore } from '@bread/js/store'
import Stats from "@admin_ui/Pages/Graphs/Stats";
import UpdatesGraph from "@admin_ui/Pages/Graphs/UpdatesGraph";

const store = useBreadStore()

const props = defineProps({
  stores: {
    type: Array,
    required: true,
  },

})

onMounted(() => store.setResource(props.resource))
</script>

<template>
  <h3 class="mt-8 text-xl">Grafieken</h3>
  <UpdatesGraph class="pt-12"/>
  <GraphChart class="pt-12"/>
  <SSTGraph class="pt-12"/>
</template>
